import { Box, SxProps } from "@mui/material";
import { useGetOnboardQuery } from "src/context/api/onboard/api";
import { usePathname } from "src/routes/hooks";
import BannersGrid from "src/sections/overview/dashboards/views/admin/onboard/grid";

export default function Section({ children, ...other }: { children: React.ReactNode } & { sx?: SxProps }) {
    const pathname = usePathname();
    const { data: allBanners, refetch } = useGetOnboardQuery();
    const banners = allBanners?.filter((banner) => banner.target === pathname);

    const routes = [
        "/brand-overview",
        "/brand/campaign-leaks",
        "/brand/brand-shield/active-mode",
        "/brand/brand-shield/scraping",
        "/brand/brand-shield/keywords/exact",
        "/brand/brand-shield/campaigns",
        "/brand/brand-shield/keywords/other",
        "/brand/brand-shield/ko-bidding/max-cpc",
        "/brand/brand-shield/ko-bidding/troas",
        "/brand/brand-shield/ko-bidding/tcpa",
        "/brand/brand-shield/ko-bidding/target-impression-share",
        "/brand/brand-shield/ko-bidding-auto",
        "/brand-wayback",
        "/admin/cockpit",
        "/admin/users",
        "/competitors/leaderboard/competitors-selection",
        "/admin/users/add",
        "/admin/sso",
        "/workspaces",
        "/competitors/leaderboard/tracked-competitors",
        "/workspaces/add",
        "/admin/features/live-bidding/ad-group-based",
        "/",
        "/non-brand/search-performance",
        "/non-brand/visibility",
        "/competitors/conquest-mode",
        "/competitors/leaderboard/market-leaders",
        "/account"
    ];

    const isSpecialRoute = routes.includes(pathname) || window.location.pathname.startsWith("/workspaces/") || window.location.pathname.startsWith("/competitor/");
    const isCompetitiveRouteButNotAds = pathname?.startsWith("/brand/visibility") && !pathname?.startsWith("/brand/visibility/ads");
    const isOptimizationRoute =
        pathname?.startsWith("/brand/search-performance") ||
        pathname?.startsWith("/brand/campaign-leaks") ||
        pathname?.startsWith("/optimization/conversions-analysis");
    const isLeaderboardRoute = pathname?.startsWith("/competitors/leaderboard/market-leaders");

    const isCompetitiveAdsRoute = pathname?.startsWith("/brand/visibility/ads");
    const isConquestModeRoute = pathname?.startsWith("/competitors/conquest-mode");

    let paddingTop = 18;
    if (isCompetitiveRouteButNotAds) paddingTop = 14;
    else if (isOptimizationRoute) paddingTop = 12;
    else if (isCompetitiveAdsRoute) paddingTop = 18;
    else if (isSpecialRoute) paddingTop = 16;
    else if (isLeaderboardRoute) paddingTop = 4;
    else if (isConquestModeRoute) paddingTop = 4;
    return (
        <Box className="section-banner-app-wrapper" sx={{ pt: paddingTop, pb: 2, ...other.sx, backgroundColor: '#F7F7F7', height: '100%' }}>
            <Box px={"24px"}>
                <BannersGrid
                    banners={banners || []}
                    edit={false}
                    dismiss={true}
                    onDismiss={refetch}
                />
            </Box>

            {children}
        </Box>
    );
}


